import { Col, Row } from "@/utils/bootstrap";
import AddressCancelBtn from "./AddressCancelBtn";
import AddressSubmitBtn from "./AddressSubmitBtn";

interface Props {
  handleCancel: () => void;
  isLoading: boolean;
  disabled: boolean;
}

const AddressManageBtns: React.FC<Props> = ({
  handleCancel,
  isLoading,
  disabled,
}) => {
  return (
    <Row className="m-0 d-flex justify-content-end mb-4 pb-4" style={{ gap: 12 }}>
      <Col className="p-0" />
      <Col className="p-0" xs={4}>
        <AddressCancelBtn onClick={handleCancel} />
      </Col>
      <Col className="p-0" xs={4}>
        <AddressSubmitBtn isLoading={isLoading} disabled={disabled} />
      </Col>
    </Row>
  );
};

export default AddressManageBtns;
